import React, { Component } from 'react';
import { TITLE } from '../consts.js';

class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="row">
          <div className="twelve columns">
            <ul className="social-links">
              <li><a href="https://www.facebook.com/penaflamencadeturku"><i className="fa fa-facebook"></i></a></li>
              <li><a href="https://www.instagram.com/turunflamenco/"><i className="fa fa-instagram"></i></a></li>
            </ul>
            <ul className="copyright">
              <li>&copy; Copyright 2019 {TITLE}</li>
            </ul>
          </div>
          <div id="go-top"><a title="Back to Top" onClick={() => window.scroll({ top: 0, left: 0, behavior: 'smooth' })}  href="#home"><i className="icon-up-open"></i></a></div>
        </div>
      </footer>
    )
  }
}

export default Footer;
